import { Grid, Stack, Typography } from '@mui/material';
import { CircleCheck, CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type PasswordValidationState = {
  hasSpecialCharacter: boolean;
  hasUpperCase: boolean;
  isMinLength: boolean;
  hasNumber: boolean;
};

export type PasswordConditionProps = {
  validationState: PasswordValidationState;
  profileData: {
    newPassword: {
      password: string;
    };
    [key: string]: unknown;
  };
};

const PasswordCondition = ({ validationState, profileData }: PasswordConditionProps) => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'login' });

  return (
    <Grid container spacing={1}>
      <Grid>
        <Stack
          direction='row'
          fontWeight={500}
          color={
            profileData.newPassword.password === ''
              ? 'text.secondary'
              : validationState.hasSpecialCharacter
                ? 'success.main'
                : 'error.main'
          }
          spacing={1}
          component={Typography}
          variant='body2'
          alignItems='center'
        >
          {profileData.newPassword.password === '' ? (
            <CircleX size={16} />
          ) : validationState.hasSpecialCharacter ? (
            <CircleCheck size={16} />
          ) : (
            <CircleX size={16} />
          )}
          <span>{t('one_special_case_character')}</span>
        </Stack>
      </Grid>
      <Grid>
        <Stack
          direction='row'
          fontWeight={500}
          color={
            profileData.newPassword.password === ''
              ? 'text.secondary'
              : validationState.hasUpperCase
                ? 'success.main'
                : 'error.main'
          }
          spacing={1}
          component={Typography}
          variant='body2'
          alignItems='center'
        >
          {profileData.newPassword.password === '' ? (
            <CircleX size={16} />
          ) : validationState.hasUpperCase ? (
            <CircleCheck size={16} />
          ) : (
            <CircleX size={16} />
          )}
          <span>{t('one_uppercase_character')}</span>
        </Stack>
      </Grid>
      <Grid>
        <Stack
          direction='row'
          color={
            profileData.newPassword.password === ''
              ? 'text.secondary'
              : validationState.isMinLength
                ? 'success.main'
                : 'error.main'
          }
          spacing={1}
          component={Typography}
          variant='body2'
          alignItems='center'
        >
          {profileData.newPassword.password === '' ? (
            <CircleX size={16} />
          ) : validationState.isMinLength ? (
            <CircleCheck size={16} />
          ) : (
            <CircleX size={16} />
          )}
          <span>{t('8_character_minimum')}</span>
        </Stack>
      </Grid>
      <Grid>
        <Stack
          direction='row'
          fontWeight={500}
          color={
            profileData.newPassword.password === ''
              ? 'text.secondary'
              : validationState.hasNumber
                ? 'success.main'
                : 'error.main'
          }
          spacing={1}
          component={Typography}
          variant='body2'
          alignItems='center'
        >
          {profileData.newPassword.password === '' ? (
            <CircleX size={16} />
          ) : validationState.hasNumber ? (
            <CircleCheck size={16} />
          ) : (
            <CircleX size={16} />
          )}
          <span>{t('one_number')}</span>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PasswordCondition;
